// Module
var code = "<script>let $ctrl</script> <div class=\"rights-checkbox\"> <atom-form-checkbox-toggle toggle=\"$ctrl.checked\" disabled=\"!$ctrl.isEditable\"></atom-form-checkbox-toggle> </div> ";
// Exports
module.exports = code;